















import { Evento, EventosService } from "@/services/eventos.service";
import Vue from "vue";
import Component from "vue-class-component";
import { ModelSync, Prop, Watch } from "vue-property-decorator";

@Component
export default class DetalhesEventoRow extends Vue {
  isLoading = true;
  @Prop({ type: Number, default: 1 }) colspan!: number;
  @ModelSync("value", "input", { type: Number, default: null })
  idEvento!: number;

  item?: Evento;

  mounted() {
    this.fetchItem();
  }

  @Watch("idEvento")
  fetchItem() {
    this.isLoading = true;
    EventosService.obter(this.idEvento)
      .then((result) => (this.item = result))
      .finally(() => (this.isLoading = false));
  }
}
